// SMART DEMO — Arteva Home asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 wardrobe + 4 tv-unit + 4 custom-furniture + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Arteva Home" tamamen kurgu demo markadır.

export const ARTEVA_HOME_ASSET_ROOT = "/demo-presets/furniture/arteva-home";

export interface ArtevaHomeManifest {
  logo: string;
  wardrobe: string[];
  tvUnit: string[];
  customFurniture: string[];
  videos: string[];
}

export const ARTEVA_HOME_MANIFEST: ArtevaHomeManifest = {
  logo: `${ARTEVA_HOME_ASSET_ROOT}/logo/logo.webp`,
  wardrobe: [
    `${ARTEVA_HOME_ASSET_ROOT}/wardrobe/01.webp`,
    `${ARTEVA_HOME_ASSET_ROOT}/wardrobe/02.webp`,
    `${ARTEVA_HOME_ASSET_ROOT}/wardrobe/03.webp`,
    `${ARTEVA_HOME_ASSET_ROOT}/wardrobe/04.webp`,
  ],
  tvUnit: [
    `${ARTEVA_HOME_ASSET_ROOT}/tv-unit/01.webp`,
    `${ARTEVA_HOME_ASSET_ROOT}/tv-unit/02.webp`,
    `${ARTEVA_HOME_ASSET_ROOT}/tv-unit/03.webp`,
    `${ARTEVA_HOME_ASSET_ROOT}/tv-unit/04.webp`,
  ],
  customFurniture: [
    `${ARTEVA_HOME_ASSET_ROOT}/custom-furniture/01.webp`,
    `${ARTEVA_HOME_ASSET_ROOT}/custom-furniture/02.webp`,
    `${ARTEVA_HOME_ASSET_ROOT}/custom-furniture/03.webp`,
    `${ARTEVA_HOME_ASSET_ROOT}/custom-furniture/04.webp`,
  ],
  videos: [
    `${ARTEVA_HOME_ASSET_ROOT}/videos/01.mp4`,
    `${ARTEVA_HOME_ASSET_ROOT}/videos/02.mp4`,
  ],
};